/**
 * @generated SignedSource<<d8a18e9c09a59ee27b62d44ef62b48dd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContactContactView_contact$data = {
  readonly __typename: string;
  readonly contactIdentifier: string;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"ContactAttributesPanel_contact" | "ContactCustomersPanel_contact" | "ContactDataList_contact" | "DeleteContactDialog_contact">;
  readonly " $fragmentType": "ContactContactView_contact";
};
export type ContactContactView_contact$key = {
  readonly " $data"?: ContactContactView_contact$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContactContactView_contact">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContactContactView_contact",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contactIdentifier",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContactDataList_contact"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContactCustomersPanel_contact"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContactAttributesPanel_contact"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DeleteContactDialog_contact"
    }
  ],
  "type": "Contact",
  "abstractKey": "__isContact"
};

(node as any).hash = "80b270058f36140c27e80a39ec27b7c3";

export default node;
